module.exports = __webpack_public_path__ + "media/property-types/Apartment_Building-25510c4d.png";